<!-- 商品分类 -->

<template>
    <div class="classify">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="clearfix" style="width:100%">
                        <div class="left search flex flex-align-center">
                            机位设置
                        </div>
                        <div class="right searchBtn">
                            <button type="button" @click="addClassify(false)"><i class="el-icon-plus"></i>新增</button>
                        </div>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th>区域名称</th>
                                <th>操作</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                               <div class="type_parent">
                                    <!-- <div class="type_title clearfix">
                                        <span class="left type_title_name flex flex-align-center">商品</span>
                                        <span class="right parent_default flex flex-align-center flex-pack-center">
                                            <i class=" iconfont icon-icon02" title="添加" @click="addClassify(false)"></i>
                                        </span>
                                    </div> -->
                                    <div class="type_parent_item type_active" v-for="(item,ind) in typeData" :style="{height:(item.isOpen&&btn?((item.children.length+1)*9+'%'):'9%')}">
                                        <div class="type_parent_text clearfix" :style="{height:(item.isOpen&&btn?(100/(item.children.length+1)+'%'):'100%')}">
                                            <div class="left type_parent_text_left flex flex-align-center" @click="handle(item,ind)">
                                                <i class="i" :class="{
                                                    'el-icon-caret-right':item.children.length  && (!item.isOpen||!btn),
                                                    'el-icon-caret-bottom':item.children.length && (!item.isOpen||btn)}"
                                                ></i>
                                                <span class="parent_default type_name" v-text="item.name"></span>
                                            </div>
                                            <div class="right ss flex flex-align-center flex-pack-center">
                                               <!-- <span style="color: #9cda71;" @click="sorting(true,item,ind)">上移</span> -->
                                               <!-- <span style="color: #f76260;" @click="sorting(false,item,ind)">下移</span> -->
                                            </div>
                                            <span class="right type_parent_text_right flex flex-align-center flex-pack-center" style="width:120px;display:flex;">
                                                <span class="left" style="font-size:14px;white-space:nowrap;width:150px;">排序值：{{item.queue}}</span>
                                                <!-- <i class=" iconfont icon-icon02" style="padding-left:50px;" title="添加" @click="addSite(item)"></i> -->
                                                <i class=" iconfont icon-icon02" style="padding-left:50px;" title="添加" @click="addSiteBatch(item)"></i>
                                                <i class="iconfont icon-bianji" title="修改" @click="upClassify(item,false)"></i>
                                                <i class=" iconfont icon-icon1460188478041" title="删除" @click="delClassify(item,false)"></i>
                                            </span>
                                        </div>
                                        <div class="type_child" v-if="item.isOpen && btn" :style="{height:(100 - 100/(item.children.length+1)+'%')}">
                                            <div class="type_child_item" v-for="(oitem,oInd) in item.children" :style="{height:(100/(item.children.length)+'%')}">
                                                <div class="type_child_left left flex flex-align-center">
                                                    <span v-text="oitem.name" class="left"></span>
                                                    <!-- <span class="left" style="margin-left:250px;font-size:14px;">排序值：{{oitem.queue}}&nbsp;&nbsp;&nbsp;IP地址：{{oitem.ipAddress}}</span>
                                                    <span class="right"></span> -->
                                                </div>
                                                <span style="display:flex;margin-right:170px">
                                                    <!-- <span class="left" style="font-size:14px;padding-right:100px;white-space:nowrap;">排序值：{{oitem.queue}}&nbsp;&nbsp;&nbsp;IP地址：{{oitem.ipAddress}}</span> -->
                                                    <span class="left" style="font-size:14px;padding-right:100px;white-space:nowrap;">IP地址：{{oitem.ipAddress}}</span>
                                                    <!-- <span class="right"></span> -->
                                                    <!-- <div class="right ss flex flex-align-center flex-pack-center"> -->
                                                        
                                                    <!-- <span style="color: #9cda71;padding-right:5px;font-size:14px;cursor:pointer;" @click="sortingChild(true,oitem,oInd,item)">上移</span> -->
                                                    <!-- <span style="color: #f76260;padding-right:5px;font-size:14px;cursor:pointer;" @click="sortingChild(false,oitem,oInd,item)">下移</span> -->
                                                <!-- </div> -->
                                                <!-- <span class="type_child_right right flex flex-align-center flex-pack-center"> -->
                                                <span class="right type_parent_text_right flex flex-align-center flex-pack-center">
                                                    <!-- <i class=" iconfont icon-icon02" title="添加" @click="addClassify(item.id)"></i> -->
                                                    <i class="iconfont icon-bianji" title="修改" style="padding-right:10px;cursor:pointer;"  @click="modifySite(item,oitem)"></i>
                                                    <i class=" iconfont icon-icon1460188478041" style="padding-right:10px;cursor:pointer;"  title="删除" @click="delSite(item,oitem)"></i>
                                                </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                               </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 分页器 -->
                <!-- <div class="pager flex flex-align-center">
                    <div class="pagerCon clearfix">
                        <div class="pagerBtnBox right">
                            <div class="pagerBtn">
                                <span class="prev flex flex-align-center flex-pack-center left"><i class="el-icon-arrow-left"></i></span>
                                <span class="curPageNumber flex flex-align-center flex-pack-center left">1</span>
                                <span class="next flex flex-align-center flex-pack-center left havePage"><i class="el-icon-arrow-right"></i></span>
                            </div>
                        </div>
                        <div class="curPage flex flex-align-center right">第 1 / 9 条</div>
                        <div class="totalPage flex flex-align-center right">共100条</div>
                    </div>
                </div> -->
            </div>
        </div>
        <el-dialog
            class="dialog"
            title="添加/编辑"
            :visible.sync="addJobVisible"
            >
            <div>
                <div class="msgBox clearfix">
                    <div class="left msgItem clearfix" style="width:100%">
                        <span class="left itemName" style="width:100px"><i>*</i>区域名称</span>
                        <input type="text" class="left itemInput" v-model="obj.name" placeholder="请输入名称">
                    </div>
                </div>
                <div class="msgBox clearfix">
                    <div class="left msgItem clearfix" style="width:100%">
                        <span class="left itemName" style="width:100px">排序值</span>
                        <input type="number" class="left itemInput" v-model="obj.queue" placeholder="请输入名称">
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="addJobVisible=false" class="cancel">取消</button>
                <button type="button" @click="addDiscount" class="save">保存</button>
            </span>
        </el-dialog>
        <!-- <el-dialog
            :title="typeName"
            :visible.sync="addJobVisible"
            size="tiny">
            <div>
                <div class="msgBox clearfix">
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>名称</span>
                        <input type="text" class="left itemInput" v-model="obj.name" placeholder="请输入名称">
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="addJobVisible=false" class="cancel">取消</button>
                <button type="button" @click="addJob" class="save">保存</button>
            </span>
        </el-dialog> -->
        <el-dialog
            class="dialog"
            title="批量添加机位"
            :visible.sync="showModifySiteBatch"
            >
            <div>
                <div class="msgBox clearfix">
                    <div class="left msgItem clearfix" style="width:100%">
                        <span class="left itemName" style="width:100px"><i>*</i>起始IP地址</span>
                        <input type="text" class="left itemInput" v-model="newBatchSite.beginIp" placeholder="如：192.168.1.1">
                    </div>
                    <div class="left msgItem clearfix" style="width:100%">
                        <span class="left itemName" style="width:110px"><i>*</i>生成机位数量</span>
                        <input type="number" class="left itemInput" v-model="newBatchSite.count" placeholder="如:50">
                    </div>
                    <!-- <div class="left msgItem clearfix" style="width:100%">
                        <span class="left itemName" style="width:100px">排序</span>
                        <input type="number" class="left itemInput" v-model="newSite.queue" placeholder="请输入">
                    </div> -->
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="showModifySiteBatch=false" class="cancel">取消</button>
                <button type="button" @click="doAddNewSiteBatch" class="save">生成</button>
            </span>
        </el-dialog>
        <el-dialog
            class="dialog"
            title="添加/编辑机位"
            :visible.sync="showModifySite"
            >
            <div>
                <div class="msgBox clearfix">
                    <div class="left msgItem clearfix" style="width:100%">
                        <span class="left itemName" style="width:100px"><i>*</i>机位名称</span>
                        <input type="text" class="left itemInput" v-model="newSite.name" placeholder="请输入">
                    </div>
                    <div class="left msgItem clearfix" style="width:100%">
                        <span class="left itemName" style="width:100px"><i>*</i>IP地址</span>
                        <input type="text" class="left itemInput" v-model="newSite.ipAddress" placeholder="请输入">
                    </div>
                    <!-- <div class="left msgItem clearfix" style="width:100%">
                        <span class="left itemName" style="width:100px">排序</span>
                        <input type="number" class="left itemInput" v-model="newSite.queue" placeholder="请输入">
                    </div> -->
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="showModifySite=false" class="cancel">取消</button>
                <button type="button" @click="doAddNewSite" class="save">保存</button>
            </span>
        </el-dialog>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    export default{
    	data () {
    		return {
                newBatchSite:{
                    regionId:"",
                    beginIp:"",
                    count:"",
                },
                showModifySiteBatch:false,
                siteType:"",
                nowSelRegion:null,
                newSite:{
                    name:'',
                    id:0,
                    regionId:"",
                    ipAddress:"",
                    queue:0,
                },
                showModifySite:false,
                // 
                addJobVisible: false,
                btn:false,//分类下拉三角样式
                typeData:[],
                obj: {
                    name:'',
                    id:'',
                    queue:0,
                },
                typeBtn: '',
                typeName: '',
                addJobBtn: true,
                systemData:[]
    		}
    	},
        watch:{
            showModifySite(val){
                if(!val){
                    this.newSite = {
                        name:'',
                        id:0,
                        regionId:"",
                        ipAddress:"",
                        queue:0,
                    };
                }
            }
        },
        methods: {
            addSiteBatch(item){
                this.newBatchSite.regionId = item.id
                this.showModifySiteBatch = true;
            },
            // 
            check(){
                //正则验证方法
                if(!this.obj.name){
                    this.$message({
                        message: '请输入名称',
                        customClass: 'error'
                    })
                    return true;
                }
                if(!/^[1-9]\d*|0$/.test(this.obj.queue)){
                    this.$message({
                        message: '排序值输入有误',
                        customClass: 'error'
                    })
                    return true;
                }
                return false;
            },
            addDiscount(){
                if(this.check()){
                    return;
                }
                this.$http({
                    url:"region/edit",
                    method:"POST",
                    data:{
                      storeId:this.$route.params.id,
                      name:this.obj.name,
                      queue:this.obj.queue,
                      id:this.obj.id,
                    }
                }).then(res=>{
                    this.$message({
                        message: res.data,
                        customClass: 'success'
                    });
                    this.addJobVisible = false;
                    this.obj.queue = "";
                    this.initData();
                    this.getDataList();
                })
                
            },
            initData(){
                this.obj = {
                    name:'',
                    id:0
                }
            },
            //添加或者修改分类
            addJob(){
                if(!this.obj.name){
                    this.$message({
                        message: '分类名称有误',
                        customClass: 'error'
                    })
                    return;
                }
                this.$set(this.obj,"name",this.obj.name.replace(/\s*/g,""));
                if(this.typeBtn == 1){
                    //添加父类
                    let data = {
                        "id"      : this.$uuid.create(1).hex,
                        "sequence":-1,
                        "name"    : this.obj.name,
                        "storeId" : this.$route.params.id,
                        "parentId": ''
                    }
                    if(!this.addJobBtn){
                        return;
                    }
                    this.addJobBtn = false;
                    this.$http.put('/product-types',data).then((res)=>{
                        this.getDataList();
                        this.addJobVisible = false ;
                        this.addJobBtn = true;
                    }).catch(()=>{
                        this.addJobBtn = true;
                    })
                }else if(this.typeBtn == 2){
                    //添加子类
                    let data = {
                        "id"      : this.$uuid.create(1).hex,
                        "name"    : this.obj.name,
                        "storeId" : this.$route.params.id,
                        "parentId": this.obj.id
                    }
                    if(!this.addJobBtn){
                        return;
                    }
                    this.addJobBtn = false;
                    this.$http.put('/product-types',data).then((res)=>{
                        this.getDataList();
                        this.addJobVisible = false ;
                        this.addJobBtn = true;
                    }).catch(()=>{
                        this.addJobBtn = true;
                    })
                }else if(this.typeBtn == 3){
                    //、、修改父类
                    let data = {
                        "id"      : this.obj.id,
                        "sequence": this.obj.sequence,
                        "name"    : this.obj.name,
                        "storeId" : this.$route.params.id,
                        "parentId": ''
                    }
                    if(!this.addJobBtn){
                        return;
                    }
                    this.addJobBtn = false;
                    this.$http.put('/product-types',data).then((res)=>{
                        this.getDataList();
                        this.addJobVisible = false ;
                        this.addJobBtn = true;
                    }).catch(()=>{
                        this.addJobBtn = true;
                    })
                }else if(this.typeBtn == 4){
                     //、、修改子类
                    let data = {
                        "id"      : this.obj.id,
                        "name"    : this.obj.name,
                        "storeId" : this.$route.params.id,
                        "parentId": this.obj.arId
                    }
                    if(!this.addJobBtn){
                        return;
                    }
                    this.addJobBtn = false;
                    this.$http.put('/product-types',data).then((res)=>{
                        this.getDataList();
                        this.addJobVisible = false ;
                        this.addJobBtn = true;
                    }).catch(()=>{
                        this.addJobBtn = true;
                    })
                }
            },
            sortingChild(boo,item,ind,pItem){
                let list = [];
                if( boo ){
                    //上移
                    for (let i = 0, len = pItem.children.length; i < len; i++) {
                        if(ind==0){
                            this.$message({
                                message: '已经是第一项了',
                                customClass: 'error'
                            })
                            return;
                        }
                        let body = {
                            "productTypeId":pItem.children[i].id,
                            "sequence":i
                        };
                        list.push(body)
                        if(ind == i){
                            list[i].sequence = i-1;
                            list[i-1].sequence = i;
                        }
                    }
                }else{
                    if(ind==pItem.children.length-1){
                        this.$message({
                            message: '已经是最后一项了',
                            customClass: 'error'
                        })
                        return;
                    }
                    let num=-1;
                    for (let i = 0, len = pItem.children.length; i < len; i++) {
                        let body = {
                            "productTypeId":pItem.children[i].id,
                            "sequence":i
                        };
                        list.push(body)
                        if(ind == i){
                            list[i].sequence = i+1;
                            num = i+1;
                        }
                        if(num == i ){
                            list[num].sequence = i-1;
                        }
                    }
                }
                this.$http.put('/product-sequence',{"products":list}).then((res)=>{
                    this.getDataList();
                }).catch((err) => {
                });
            },
            //排序
            sorting(boo,item,ind){
                let list = [];
                if( boo ){
                    //上移
                    for (let i = 0, len = this.typeData.length; i < len; i++) {
                        if(ind==0){
                            this.$message({
                                message: '已经是第一项了',
                                customClass: 'error'
                            })
                            return;
                        }
                        let body = {
                            "productTypeId":this.typeData[i].id,
                            "sequence":i
                        };
                        list.push(body)
                        if(ind == i){
                            list[i].sequence = i-1;
                            list[i-1].sequence = i;
                        }
                    }
                }else{
                    if(ind==this.typeData.length-1){
                        this.$message({
                            message: '已经是最后一项了',
                            customClass: 'error'
                        })
                        return;
                    }
                    let num=-1;
                    for (let i = 0, len = this.typeData.length; i < len; i++) {
                        let body = {
                            "productTypeId":this.typeData[i].id,
                            "sequence":i
                        };
                        list.push(body)
                        if(ind == i){
                            list[i].sequence = i+1;
                            num = i+1;
                        }
                        if(num == i ){
                            list[num].sequence = i-1;
                        }
                    }
                }
                this.$http.put('/product-sequence',{"products":list}).then((res)=>{
                    this.getDataList();
                }).catch((err) => {
                });
            },
            getDataList(){
                this.$http({
                    url:"region/list",
                    method:"POST",
                    data:{
                        storeId:this.$route.params.id
                    }
                }).then(res=>{
                    if(res.data && Array.isArray(res.data) && res.data.length){
                        res.data.forEach(it=>{
                            it.children = [];
                            it.isOpen= true;
                            this.btn = true;
                            if(it.nums && Array.isArray(it.nums)){
                                it.children = it.nums;
                            }
                        })
                    }
                    this.typeData = res.data;
                })
            },
            addClassify(id){
                //添加分类
                this.typeName = "添加/编辑"
                this.obj = {
                    name:'',
                    id:'',
                    arId:''
                };
                this.addJobVisible = true ;
                this.obj.id = id?id:'';
                this.typeBtn = id?2:1;
            },
            checkSite(){
                //正则验证方法
                let ipReg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
                if(!this.newSite.name){
                    this.$message({
                        message: '请输入名称',
                        customClass: 'error'
                    })
                    return true;
                }
                if(!ipReg.test(this.newSite.ipAddress)){
                    this.$message({
                        message: 'ip地址有误',
                        customClass: 'error'
                    });
                    return true;
                }
                // if(!/^[1-9]\d*|0$/.test(this.newSite.queue)){
                //     this.$message({
                //         message: '排序值输入有误',
                //         customClass: 'error'
                //     })
                //     return true;
                // }
                // 
                if(this.siteType != "edit"){
                    if(this.typeData && Array.isArray(this.typeData)){
                        let typeData = JSON.parse(JSON.stringify(this.typeData));
                        let ips = [];
                        typeData.forEach(it=>{
                            if(it.nums && Array.isArray(it.nums)){
                                it.nums.forEach(ite=>{
                                    ips.push(ite.ipAddress);
                                })
                            }
                        });
                        if(ips.indexOf(this.newSite.ipAddress)!=-1){
                            this.$message({
                                message: '已添加过此IP',
                                customClass: 'error'
                            })
                            return true;
                        }
                    }
                }
                
                // 
                return false;
            },
            doAddNewSiteBatch(){
                let ipReg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
                if(!ipReg.test(this.newBatchSite.beginIp)){
                    this.$message({
                        message: 'ip地址有误',
                        customClass: 'error'
                    });
                    return true;
                }
                if(!this.newBatchSite.count || this.newBatchSite.count<1 || this.newBatchSite.count>256){
                    this.$message({
                        message: '数量填写有误',
                        customClass: 'error'
                    });
                    return true;
                }
                this.$http({
                    url:"region/batch/add/num",
                    method:"POST",
                    data:{
                        ...this.newBatchSite
                    }
                }).then(res=>{
                    this.$message({
                        message: "操作成功",
                        customClass: 'success'
                    });
                    this.newBatchSite = {
                        regionId:"",
                        beginIp:"",
                        count:"",
                    }
                    this.showModifySiteBatch = false;
                    this.getDataList();
                })
            },
            doAddNewSite(){
                if(this.checkSite()){
                    return;
                }
                this.$http({
                    url:this.siteType ? "region/edit/num" : "region/add/num",
                    method:"POST",
                    data:{
                      storeId:this.$route.params.id,
                      name:this.newSite.name,
                      id:this.newSite.id,
                      regionId:this.nowSelRegion.id,
                      ipAddress:this.newSite.ipAddress,
                      queue:this.newSite.queue,
                    }
                }).then(res=>{
                    this.$message({
                        message: "操作成功",
                        customClass: 'success'
                    });
                    if(this.siteType == "edit"){
                        this.showModifySite = false;
                        this.initDataForSite();
                    }
                    this.siteType = "";
                    this.getDataList();
                })
            },
            initDataForSite(){
                this.newSite = {
                    name:'',
                    id:0,
                    regionId:"",
                    ipAddress:"",
                    queue:"",
                }
            },
            addSite(item){
                this.siteType = "";
                this.nowSelRegion = item;
                this.showModifySite = true;
            },
            upClassify(item,oitem){
                //修改分类
                this.typeName = "修改";
                if(!oitem){
                    this.obj = {
                        name:item.name,
                        id: item.id,
                        queue:item.queue,
                    };
                    this.addJobVisible = true ;
                    this.typeBtn = oitem ? 4:3;
                }
            },
            modifySite(item,oitem){
                this.nowSelRegion = item;
                this.newSite = {
                    name:oitem.name,
                    id:oitem.id,
                    regionId:item.id,
                    ipAddress:oitem.ipAddress,
                    queue:oitem.queue,
                }
                this.showModifySite = true;
                this.siteType = "edit";
            },
            delSite(item,oitem){
                this.$confirm(`是否删除该机位`, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    this.$http({
                        url:"region/delete/num",
                        method:"POST",
                        data:{
                            id:oitem.id
                        }
                    }).then(res=>{
                        this.getDataList();
                    })
                }).catch(() => {});
            },
            delClassify(item,oitem){
                this.$confirm(`是否删除 ${ oitem ? (oitem.name+' 区域?'):item.name+' 区域及该区域下所有机位?'}`, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    this.$http({
                        url:"region/delete",
                        method:"POST",
                        data:{
                            id:item.id
                        }
                    }).then(res=>{
                        this.getDataList();
                    })
                }).catch(() => {});

            },
            handle(item,ind){
                if(this.typeData[ind].isOpen){
                    this.btn = !this.btn;
                }else{
                    this.btn = true ;
                }
                for(var i = 0,len = this.typeData.length; i < len;i++){
                   this.typeData[i].isOpen = false;
                }
                this.typeData[ind].isOpen  = true;
            }
        },
        activated: function () {
            this.getDataList();
            //就怕sequence会大于数组的长度
            // this.$http.get('/product-types?storeId='+this.$route.params.id+'&parentId='+'').then((res)=>{
            //     console.log(res.data)
            //     let body = res.data.data;
            //     this.systemData = res.data.systemData;
            //     let newArr = []; 
            //     for (let i = 0, len = body.length; i < len; i++) {
            //         if ( !body[i].parent ) {
            //             body[i].isOpen = false;
            //             newArr.push(body[i]);
            //             newArr[newArr.length-1].children = [];
            //             for (let j = 0, len = body.length; j < len; j++) {
            //                 if ( body[j].parent&&body[i].id==body[j].parent.id) {
            //                     newArr[newArr.length-1].children.push(body[j]);
            //                 }
            //             }
            //         }
            //     }
            //     let list = [];
            //     for (let i = 0, len = newArr.length; i < len; i++) {
            //         let bodys = {
            //             "productTypeId":newArr[i].id,
            //             "sequence":i
            //         };
            //         list.push(bodys)
            //     }
            //     if(!list.length){
            //         return;
            //     }
            //     this.$http.put('/product-sequence',{"products":list}).then((res)=>{
            //         this.getDataList();
            //     }).catch((err) => {
            //     });
            // }).catch((err) => {
            // });
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    @import '../../tableTemplate/el-dialog.scss';
	@import "region.scss";
</style>



// WEBPACK FOOTER //
// region.vue?134b1f18